export const getIdFromIri = (value: string) => {
    if (!value) return null;
    const n = value.lastIndexOf('/');
    return value.substring(n + 1);
};
